import { toastStore } from '../stores/toastStore';

export default function useToast() {
  const { openToast, setOpenToast } = toastStore();
  return {
    openToast,
    setOpenToast,
  };
}
